module.exports = __webpack_public_path__ + "img/down-notes.4f8e312c.png";